import Alpine from 'alpinejs';

Alpine.data('parallax', () => ({
    isMobile: () => window.matchMedia('(max-width: 48rem)').matches,
    percent: 0,
    rect: {},
    offset: {
        top: 0,
        bottom: 0,
    },
    isHighEnough: true,

    init() {
        let elementNode = this.$root;
        /**
            // from top to bottom, elementTop == windowBottom -> elementBottom == windowTop
            this.offset = {
                top: -this.rect.height,
                bottom: -this.rect.height,
            };
            // from bottom to bottom, elementBottom == windowBottom -> elementBottom == windowTop
            this.offset = {
                top: -this.rect.height,
                bottom: 0,
            };
            // from top to top, elementTop == windowBottom -> elementTop == windowTop
            this.offset = {
                top: 0,
                bottom: -this.rect.height,
            };
            // from bottom to top, elementBottom == windowBottom -> elementTop == windowTop
            this.offset = {
                top: 0,
                bottom: 0,
            };
         */

        let debounce = (cb, timeout = 50) => {
            let timer;
            return (...args) => {
                clearTimeout(timer);
                timer = setTimeout(() => {
                    cb.apply(this, args);
                }, timeout);
            };
        };

        // check is component visible on screen
        let isBelow = (rect) => {
            return rect.bottom + this.offset.bottom > (window.innerHeight || document.documentElement.clientHeight);
        };

        let isAbove = (rect) => {
            return rect.top - this.offset.top < 0;
        };

        // set current scroll factor value [1 > factor > 0]
        let setPercent = (percent) => {
            percent = Math.abs(percent);
            elementNode.style.setProperty('--scrolled-percent-in-viewport', percent);
        };

        // calc current factor value
        let calc = (rect) => {
            let topPoint = rect.top - this.offset.top;
            let bottomPoint = window.innerHeight - rect.height - this.offset.top - this.offset.bottom;

            // when component out of view, set value to its edge, 1 if scrolled below, 0 if above.
            return isAbove(this.rect) ? 1 : isBelow(this.rect) ? 0 : (topPoint / bottomPoint - 1).toFixed(4);
        };

        // set initial value (on load) + update value on scroll and resize
        ['DOMContentLoaded', 'scroll', 'resize'].forEach((event) => {
            window.addEventListener(event, () => {
                this.rect = elementNode.getBoundingClientRect();
                this.percent = calc(this.rect);
                let minThreshold = !this.isMobile() ? 100 : 30; // minimal animation length
                let heightDiff = window.innerHeight - this.rect.height;
                let topPoint = elementNode.parentNode.offsetTop;
                let maxTopOffset = topPoint + window.innerHeight - document.body.getBoundingClientRect().height;

                this.offset = {
                    top: !this.isMobile() ? heightDiff * 0.33 : maxTopOffset > 0 ? maxTopOffset : 0, // px animation top offset, 350 - min footer height
                    bottom: !this.isMobile() ? 20 : 0, // px animation bottom offset, but not more than bottom of the page
                };

                this.isHighEnough = heightDiff - this.offset.top - this.offset.bottom - minThreshold >= 0;

                // disable animation if window/device height smaller than component height
                if (!this.isHighEnough) {
                    elementNode.style.setProperty('--scrolled-percent-in-viewport', 1);
                    return;
                }

                debounce(setPercent(this.percent));
            });
        });
    },
}));
